import { useMemo } from 'react';

const RATINGS = [
  { name: 'ניצוץ', threshold: 0 },
  { name: 'לפיד', threshold: 1000 },
  { name: 'מגדלור', threshold: 2000 },
  { name: 'חומת מגן', threshold: 3000 },
] as const;

type Rank = (typeof RATINGS)[number]['name'];

interface RatingResult {
  rank: Rank;
  amountToNextLevel: number;
}

export function useRating(currentPoints: number): RatingResult {
  return useMemo(() => {
    const points = Math.max(0, currentPoints);

    const currentLevel =
      [...RATINGS].reverse().find(level => points >= level.threshold) ??
      RATINGS[0];

    const currentIndex = RATINGS.findIndex(level => level === currentLevel);
    const nextLevel = RATINGS[currentIndex + 1];

    return {
      rank: currentLevel.name,
      amountToNextLevel: nextLevel
        ? nextLevel.threshold - points
        : 0,
    };
  }, [currentPoints]);
}